"use client";

/**
 * SidebarPull Component
 *
 * A pull arrow that appears on the left side of the screen in mobile view
 * to allow users to open the sidebar with a click or swipe.
 */
import React from "react";
import { FaChevronRight } from "react-icons/fa";

function SidebarPull(props) {
  return (
    <div
      className={`sidebar-pull ${props.isSidebarOpen ? "open" : ""}`}
      onClick={props.onClick}
    >
      <FaChevronRight className="pull-icon" />
    </div>
  );
}

export default SidebarPull;